import { useEffect, useRef, useState } from "react";

const InfoRole = (props) => {
    const [idRole, setIdRole] = useState(props.idRole)
    const role = props.eventosLocal.find((elemento) => elemento.id == idRole)
    const referenciaCartao = useRef({})

    useEffect(()=>{
        if(referenciaCartao.current[idRole]){
            referenciaCartao.current[idRole].scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest'
            })
        }
    }, [idRole])

    return(
        <div className="flex flex-col w-screen items-center text-gray-700">
            <div className="text-white text-2xl font-semibold py-2">Proximos Rolês</div>
            <div className="flex flex-row w-full sm:max-w-2xl px-6 gap-2 overflow-x-auto scrollbar-hide snap-x snap-mandatory scroll-smooth">
                {props.eventosLocal.sort((a, b)=>{
                    const [diaA, mesA, anoA] = a.data.split('/')
                    const [diaB, mesB, anoB] = b.data.split('/')
                    const dataA = new Date(`${anoA}-${mesA}-${diaA}T${a.horaInicio}`)
                    const dataB = new Date(`${anoB}-${mesB}-${diaB}T${b.horaInicio}`)
                    return dataA - dataB
                }).map((item) => (
                    <div ref={(elemento) => (referenciaCartao.current[item.id] = elemento)} onClick={() => setIdRole(item.id)} key={item.id} className={`snap-center shrink-0 flex flex-col min-w-[65vw] sm:min-w-[20vw] max-w-[300px] items-center justify-around p-4 rounded-xl shadow-md transition-transform duration-300 scale-95 ${idRole == item.id ? 'bg-purple-700 text-white' : 'bg-white'}`}>
                        <h2 className="text-lg font-bold">{item.nome}</h2>
                        <div className="flex flex-col justify-around items-center gap-2 text-xl">
                            <div className="flex gap-4">
                                <p>{`${item.data.split('/')[0]}/${item.data.split('/')[1]}`}</p>
                                <span>-</span>
                                <p>{item.horaInicio}</p>
                            </div>
                            {item.valor == 0 ? <p>Gratis</p> : <p>R$ {item.valor}</p>}
                            
                        </div>
                    </div>
                ))}
            </div>

            <div className="flex flex-col items-center mt-4 bg-white p-6 rounded-2xl shadow-lg max-w-2xl">
                {role.img && (
                    <img src={role.img} alt={role.nome} className="rounded-xl mb-4 w-full object-cover max-h-64" />
                )}
                
                <h1 className="text-2xl font-extrabold mb-2">{role.nome}</h1>

                <div className="flex flex-col items-center">
                    <p className="text-md">{role.data} - {role.horaInicio}</p>
                    <p className="text-md">{role.categoria}</p>

                    {role.subcategoria && (
                        <div className="flex gap-2 flex-wrap mt-2">
                            {JSON.parse(role.subcategoria).map((item, index) => (
                                <span key={index} className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm">
                                    {item}
                                </span>
                            ))}
                        </div>
                    )}
                </div>

                <div className="flex items-center gap-4 mt-6">
                    {role.link && (
                        <a href={role.link} target="_blank" rel="noopener noreferrer">
                            <button className="bg-purple-600 text-white px-4 py-2 rounded-xl hover:bg-purple-700 transition">
                                Ver Evento
                            </button>
                        </a>
                    )}
                    <p className="text-xl font-bold text-purple-800">R$ {role.valor}</p>
                </div>

                {/*<div className="bg-white shadow-md border border-gray-200 whitespace-pre-line break-words text-gray-700 text-[15px] leading-relaxed px-5 py-6 rounded-2xl my-6 w-full max-w-2xl">
  <h2 className="text-2xl font-bold text-purple-800 mb-4">Descrição do Evento</h2>
  <div>{role.descricao}</div>
</div>*/}

                <div className="flex flex-col mt-10 items-center">
                    <div className="text-sm text-center text-purple-800 bg-purple-100 p-3 rounded-xl my-4 max-w-md">
                        A <strong>Área de Relacionamento</strong> permite que você veja e interaja com outras pessoas que também estão curtindo o rolê. Para manter o ambiente seguro e real, essa função só é liberada quando você estiver fisicamente no local do evento.
                    </div>
                    <button className="bg-purple-700 text-white px-4 py-2 mb-10 rounded-full text-xs hover:bg-purple-800 transition-colors" onClick={()=>{
                        alert(`Você está a ${role.distancia}km. A área de relacionamento é exclusiva para quem está no local do evento. Isso garante que apenas os participantes reais possam interagir entre si. Vá até o local do rolê para desbloquear essa função!`)
                    }}>Entrar no Rolê</button>
                </div>
            </div>
        </div>
    )
}

export default InfoRole
